export const initialPagoFilters = {
  search: "",
  estado_pago: "all",
  metodo_pago: "all",
  tipo_pago: "all",
  fecha_desde: "",
  fecha_hasta: "",
  comprobante: "all",
};



export const estadosPagoOptions = [
  { value: "pendiente", label: "Pendiente" },
  { value: "parcial",   label: "Pago parcial" },
  { value: "pagado",    label: "Pagado" },
  { value: "anulado",   label: "Anulados" },
];
